import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import PropTypes from "prop-types";
import React from "react";
import RCPagination from "rc-pagination";
import { appendClassName } from "./view-helpers";

function Paging(_ref) {
  var className = _ref.className,
      current = _ref.current,
      resultsPerPage = _ref.resultsPerPage,
      onChange = _ref.onChange,
      totalPages = _ref.totalPages,
      rest = _objectWithoutProperties(_ref, ["className", "current", "resultsPerPage", "onChange", "totalPages"]);

  return React.createElement(RCPagination, _extends({
    current: current,
    onChange: onChange,
    pageSize: resultsPerPage,
    total: totalPages * resultsPerPage,
    className: appendClassName("sui-paging", className)
  }, rest));
}

Paging.propTypes = {
  current: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  resultsPerPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  className: PropTypes.string
};
export default Paging;